import React from "react";
import { useDispatch } from "react-redux";
import fileErrorIconAsset from "../../../assets/icons/ic-file-error.svg";
import { SpacingBox } from "../../../components/layout/spacing-box";
import { Typography } from "../../../components/typography/typography";
import { DatalayerModalPixieButton } from "../../../libs/datalayer/components/datalayer-modal-pixie-button";
import { ClosePayrollFileErrorModal } from "../../../redux/payroll-file/actions/default";

const LimitWorkersModal: React.FC = () => {
    const dispatch = useDispatch();

    const closeModal = () => {
        dispatch(new ClosePayrollFileErrorModal().create());
    };

    return (
        <div className="limit-workers-modal">
            <img src={fileErrorIconAsset} />
            <SpacingBox mt={33} />
            <Typography fontSize={20} variant="gray-dark-2">
                <b>
                    Superaste la cantidad
                    <br />
                    máxima de trabajadores
                </b>
            </Typography>
            <SpacingBox mt={19} />
            <SpacingBox pl={17} pr={17}>
                <Typography fontSize={16} variant="gray-dark-2">
                    El número máximo de personas que se pueden asegurar es hasta
                    200 trabajadores.
                </Typography>
            </SpacingBox>
            <SpacingBox mt={19} />
            <DatalayerModalPixieButton
                type="button"
                kind="secondary"
                fluid
                inverse
                onClick={closeModal}
                label="Aceptar"
            >
                Aceptar
            </DatalayerModalPixieButton>
        </div>
    );
};

export default LimitWorkersModal;
